import { HttpClient } from '@angular/common/http';
import { Injectable, Output, EventEmitter } from '@angular/core';
import { SoundsProvider } from '../sounds/sounds';

/*
  Generated class for the HidScannerProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class HidScannerProvider {
  @Output() scan: EventEmitter<any> = new EventEmitter<any>();
  private listening: boolean = false;
  private currentScan: any = [];
  private listenFunc:any;

  constructor(private sounds: SoundsProvider) {
    this.listenFunc = (event) => this.keyupListner(event);//UGH
  }
  ngOnInit(): void {
    this.start();
  }
  start(): void{
    window.addEventListener('keyup',this.listenFunc, true);
  }
  stop(): void{
    window.removeEventListener('keyup',this.listenFunc, true);
  }
  keyupListner(e){
    // check the keys pressed are numbers
    if (e.which >= 32 && e.which <= 122) {
      // if a number is pressed we add it to the chars array
      this.currentScan.push(String.fromCharCode(e.which));
    } else if (e.which === 13) {
      //enter key, scan must be done. TODO: use this, not scan length...
    }
    if (this.listening == false) {
      // we set a timeout function that expires after .5 sec, once it does it clears out a list of characters
      setTimeout(() => {
        if (this.currentScan.length >= 4) {
          const barcode = this.currentScan.join("");
          // console.log(barcode);
		  this.scan.emit(barcode);
		  this.sounds.playBeepSound();
        }
        this.currentScan = [];
        this.listening = false;
      }, 450); //this timeout has been tested, seems optimal
    }
    // set press to true so we do not reenter the timeout function above
    this.listening = true;
  }
}



// WEBPACK FOOTER //
// ./src/providers/hid-scanner/hid-scanner.ts